module.exports = __webpack_public_path__ + "static/media/spacer.ce7b553c.svg";